// //for PROD Tenant Environment
export const environment = {
  production: true,
  tenant: "5b268d57-2a6f-4e04-b0de-6938583d5ebc",
  clientID: 'a8f5e899-6c14-488e-b440-6332da55934a',
  authority: 'https://login.microsoftonline.com/5b268d57-2a6f-4e04-b0de-6938583d5ebc',
  storeAuthStateInCookie: false,
  defaultScope: "api://a8f5e899-6c14-488e-b440-6332da55934a/AccessAsUser",
  redirectUri : "https://mercuryqa.products.abbott",
  apiBaseURL: "/api",
  apiURL: "https://mercuryqa.products.abbott"
};
